import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
	isResultsRoute,
	loadSponsorsCatalog,
	pickWeightedBanner,
} from '../services/sponsorsService';

/**
 * Tirage pondéré à chaque navigation dans le parcours résultats par équipes
 * (liste, fiche équipe, fiche joueur, changement d’onglet vue moderne).
 */
export function useSponsorBanner(redrawKey) {
	const { pathname } = useLocation();
	const [banner, setBanner] = useState(null);

	useEffect(() => {
		let cancelled = false;

		(async () => {
			if (!isResultsRoute(pathname)) {
				if (!cancelled) setBanner(null);
				return;
			}

			try {
				const catalog = await loadSponsorsCatalog();
				if (!cancelled) {
					setBanner(pickWeightedBanner(catalog));
				}
			} catch {
				if (!cancelled) setBanner(null);
			}
		})();

		return () => { cancelled = true; };
	}, [pathname, redrawKey]);

	return banner;
}
